import Head from 'next/head';
import { usePartner } from '@/providers/Partner';
import { useEffect, useState } from 'react';

export default function SiteTile() {
    const partner = usePartner();
    const [title, setTitle] = useState('CondoLivre');
    const [favicon, setFavicon] = useState('/favicon.ico');

    useEffect(() => {
        setTitle(partner.company.name);
        setFavicon(partner.company.favicon);
    }, [partner]);

    return (
        <Head>
            <title>{title}</title>
            <link rel="shortcut icon" href={favicon} />
        </Head>
    );
}
